export default "__VITE_ASSET__FkRK4Uc3__"